import styled, { keyframes } from 'styled-components'

import { darkSlateBlue } from '../../../../styles/settings/colors'

import { txt16OpenSansBold, title28GalanoBold } from '../../../../styles/settings/types'

import rem from '../../../../styles/tools/rem'
import em from '../../../../styles/tools/em'

import media from '../../../../styles/tools/media'

const animateCheck = keyframes`
    0% {
        transform: translateX(-50%) translateY(-50%) scale(0.6);
    }

    40% {
        transform: translateX(-50%) translateY(-50%) scale(1.3);
    }

    70% {
        transform: translateX(-50%) translateY(-50%) scale(.8);
    }

    100% {
        transform: translateX(-50%) translateY(-50%) scale(1);
    }
`

export const CheckBoxContainer = styled.li`
  ${({ disabled }) => disabled && `pointer-events: none;`};
  ${({ disabled }) => disabled && `opacity: 0.3;`};
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: ${rem('40px')};
`

export const CheckIcon = styled.i`
  animation: 0.4s ${animateCheck} forwards;
  color: white;
  display: none;
  height: auto;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) scale(1);
  width: auto;
`
export const Label = styled.span`
  color: ${darkSlateBlue};
  ${txt16OpenSansBold};
  margin-left: ${rem('10px')};
`

export const Box = styled.span`
  ${({ checked }) => checked && `display: block`};
  position: relative;
  border: solid ${rem('2px')} ${darkSlateBlue};
  border-radius: ${rem('4px')};
  box-shadow: 0;
  display: block;
  height: ${rem('16px')};
  min-width: ${rem('16px')};
  min-height: ${rem('16px')};
  position: relative;
  transition: 0.3s box-shadow;
  width: ${rem('16px')};
`

export const InputCheckbox = styled.input.attrs({
  type: 'checkbox'
})`
  opacity: 0;
  display: block;
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  &:checked + ${Box} {
    background: ${darkSlateBlue};
    ${CheckIcon} {
      display: block;
    }
  }
`

export const Container = styled.section`
  width: 100%;
  padding: ${rem('9px')} 0 ${rem('17px')};
  background-color: white;
  display: flex;
  justify-content: center;
`

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: ${rem('940px')};
`

export const ServicesCheckboxesContainer = styled.div`
  ${media.large`
        padding: 0;
    `};
  ${media.small`
        margin: 0 ${rem('-24px')};
        overflow: auto;
        padding: 0 ${rem('20px')};
    `};
`

export const ServicesCheckboxes = styled.ul`
  display: flex;
  justify-content: flex-start;
  list-style: none;
  margin: 0;
  min-height: ${rem('76px')};
  padding: 0;

  ${media.small`
        display: block;
        padding-right: 10%;
        width 212%;

        :after {
            clear: both;
            content: '';
            display: table;
        }
    `};
`

export const Title = styled.h1`
  letter-spacing: ${em('0.4px')};
  color: ${darkSlateBlue};
  margin-top: ${rem('25px')};
  margin-bottom: ${rem('30px')};
  ${title28GalanoBold};
  letter-spacing: normal;
  line-height: 1;
`



// WEBPACK FOOTER //
// ./src/app/modules/StatementsFilterForm/FilterByServices/styles.js